import { detectOS } from "@/lib/detect-os";
import { isTauri } from "@/lib/is-tauri";
import { runtimeUpdateSupported } from "@/desktop/onboarding/runtime-background-run";
import {
  runtimeSetupMode,
  type RuntimeSetupMode,
} from "@/desktop/onboarding/runtime-setup-mode";
import {
  runtimeActionRequest,
  type RuntimeHealthIssue,
} from "./runtime-health";

/** Checks capabilities without mounting a setup controller or starting a run. */
export async function resolveRuntimeActionMode(
  issue: RuntimeHealthIssue,
): Promise<RuntimeSetupMode> {
  const os = detectOS() ?? "linux";
  const request = runtimeActionRequest(issue, os);
  if (!request) return "copy";
  const mode = runtimeSetupMode({
    os,
    tauri: isTauri(),
    cli: request.choice.id,
    kind: request.kind,
    updateSupported: true,
  });
  if (mode === "copy" || request.kind !== "update") return mode;
  return request.executablePath &&
    (await runtimeUpdateSupported(request.choice, request.executablePath))
    ? mode
    : "copy";
}
